export const AUTH_LOADING = "AUTH_LOADING";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_CLEAR = "AUTH_CLEAR";
export const AUTH_IN_PROGRESS = "AUTH_IN_PROGRESS";
export const AUTH_BLANK_STATE = "AUTH_BLANK_STATE";
export const SET_USER = "SET_USER";

export const SET_AUTH = "SET_AUTH";
export const VERIFY_AUTH = "VERIFY_AUTH";
export const TOKEN_LOADING = "TOKEN_LOADING";
export const TOKEN_SUCCESS = "TOKEN_SUCCESS";
export const TOKEN_FAILED = "TOKEN_FAILED";
